import React, { Component } from 'react';

class BotMessageTextNoIcon extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div className={`message message-operator no-icon ${this.props.classN}`}>                
                <span className="message-content">{this.props.children}</span>
            </div>        
        )
    }
}
BotMessageTextNoIcon.propTypes = {
    children: React.propTypes.node,
    classN: React.propTypes.node,
}
export default BotMessageTextNoIcon;